module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chtit"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_img01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If I were Italian, all this would be in plural.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Me, myself, and I forming a “we.” Sort of like a royal “we,” a “we” that remains unamused.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In Italian, graffiti is plural, it cannot be singular.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As if the black “I” were not enough to stand on its own on this white page of a world.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As if the black “I” were blind to the possibility of beauty the illustrated walls could provide.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But I’m not Italian.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I’m American.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("And, here, graffiti is singular.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("All it takes is one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Here, in America. Still breathing American air, still looking out the window at drought-stricken American trees, browning American grass.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On the maps, it says I’m close to the Pacific, and yet I can neither smell the salt air nor hear the waves lap the shore like a thirsty dog.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Everywhere I go, your Rubicon has already been marked, evidence that you arrived, you analyzed, and you conquered with spray cans and bubbled letters, with the faces you conjured, some with pointed stares emanating from the sunken eyes, some with aviator shades covering the windows to the wild souls.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sometimes, I try to find meaning, clues in the densely gathered shapes you’ve left behind. Sometimes I can make out the Vitruvian man spread-eagle against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Is that you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sometimes the “I” is an affirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Yes, I am alive. Yes, there are ten trillion stars in the sky, and I will neither see them all nor name them all before I die.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But while I’m here, still breathing this American air, still painting my pictures, and looking for you in every illustrated street corner, I will try.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae1a04a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap04.vue
// module id = 75
// module chunks = 0